import { ReactNode } from 'react';
import { StyleProps, createMultiStyleConfigHelpers } from '@chakra-ui/react';
import { cardAnatomy } from '@chakra-ui/anatomy';

import { IconName } from '@/components/atomic/v1/icon/Icon';
import { ButtonColor, ButtonSize } from '@/components/atomic/v1/button/Button';

import { myomersMediaVariant } from './MediaCard';
import { myomersDefaultVariant } from './Card';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(cardAnatomy.keys);

type ColorStripTypes = 'purple.100' | 'blue.100' | 'green.100' | 'yellow.100' | 'orange.75' | 'navy.75';

export type CardVariants = 'myomersDefault' | 'myomersMedia' | 'none';
export type CardLayouts = 'horizontal' | 'vertical';
export type CardOutline = 'drop-shadow' | 'border';
export interface CommonCardProps {
  headerText?: string | undefined;
  bodyContent?: ReactNode; // Content of the body of the card
  colorStripColor?: ColorStripTypes | undefined;
  layout?: CardLayouts;
  eyebrowText?: string | undefined | ReactNode;
  primaryBtnText?: string | undefined | ReactNode;
  primaryBtnUrl?: string | undefined;
  secondaryBtnText?: string | undefined;
  secondaryBtnUrl?: string | undefined;
  secondaryBtnSize?: ButtonSize | undefined;
  secondaryBtnRightIconName?: IconName | undefined;
  btnColor?: ButtonColor;
  footerLinkText?: string | undefined;
  footerLinkUrl?: string | undefined;
  icon?: IconName | undefined;
  iconSize?: 24 | 48;
  cardOutline?: CardOutline;
  basePadding?: number | undefined;
  bodyPadding?: number;
  height?: string | undefined;
}

const baseStyleSpacing: StyleProps = {
  display: 'flex',
  flexDirection: 'column',
  rowGap: 4,
  p: 0
};

const baseStyle = definePartsStyle({
  container: {
    backgroundColor: 'white',
    borderRadius: '10px',
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    overflow: 'hidden'
  },
  header: baseStyleSpacing,
  body: baseStyleSpacing
});

export const cardTheme = defineMultiStyleConfig({
  baseStyle,
  variants: {
    myomersDefault: myomersDefaultVariant,
    myomersMedia: myomersMediaVariant,
    none: {}
  }
});
